import { Link, NavLink } from 'react-router-dom';
import './navbar-style.css';

function Navbar({ currentPage, onNavigate }) {
    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <Link to="/" className="logo-link">
                    <img src="/images/main-icon.png" alt="Gemelas Villalobos Logo" className="logo-icon" />
                    <span className="logo-text">Gemelas Villalobos</span>
                </Link>
            </div>
            
            <ul className="navbar-nav">
                <li><NavLink to="/" className={({ isActive }) => isActive ? 'nav-link nav-link--active' : 'nav-link'}>Inicio</NavLink></li>
                <li><NavLink to="/nosotros" className={({ isActive }) => isActive ? 'nav-link nav-link--active' : 'nav-link'}>Nosotros</NavLink></li>
                <li><NavLink to="/servicios" className={({ isActive }) => isActive ? 'nav-link nav-link--active' : 'nav-link'}>Servicios</NavLink></li>
                <li><NavLink to="/portfolio" className={({ isActive }) => isActive ? 'nav-link nav-link--active' : 'nav-link'}>Portafolio</NavLink></li>
                <li><NavLink to="/contacto" className={({ isActive }) => isActive ? 'nav-link nav-link--active' : 'nav-link'}>Contacto</NavLink></li>
            </ul>
        </nav>
    );
}

export default Navbar;